import { useState, useEffect, useContext, useCallback } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../../redux/slices/treeSlice";
import { useTranslation } from "react-i18next";
import { api, useGetPdcListQuery } from '../../../redux/api';
import TPCheckbox from '../TPCheckbox';
import { Button, Autocomplete, TextField, Snackbar, Alert } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { debounce } from "lodash";
import { changePropOnAllFields } from '../OutboundTemplatePropertiesFields';

export default function DatabaseForm() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const { account , user } = useSelector(state => state.queryParams);
  const [pdcInLoading, setPdcInLoading] = useState(true);
  const [connection, setConnection] = useState('');
  const [showAlert,setShowAlert] = useState({mssg:'',type:'success',isOpen:false});
  const [connectionInput, setConnectionInput] = useState('');
  const [connectionOptions, setConnectionOptions] = useState([]);
  const [columnsSorted, setColumnsSorted] = useState(false);
  const [decodeData, setDecodeData] = useState(false);
  const [includeNull,setIncludeNull] = useState(false);
  const pdcRes = useGetPdcListQuery({ datatype: 'database', account: account, direction: 'in' });
  const connectedToDB = useSelector(state=>state.treeData[parentScreen].rightTree.connectedToDB)
  const tDataAllTabs = rightTree.tree;

  const connectToDatabaseHandler = () =>{
    if(!connectedToDB){
      dispatch(api.endpoints.connect_to_selected_db.initiate({
        account:account,
        user:user,
        direction:parentScreen === 'inbound' ? 'IN' : 'OUT',
        pdc_name:connection
      }))
      .then(res=>{
        if(res.data.current_state === 'SUCCESS'){
          setShowAlert({mssg:res.data.message,isOpen:true,type:'success'})
          dispatch(treeActions.setConnectedToDB({
            screen:parentScreen,
            value:true
          }))
        }else{
          setShowAlert({mssg:res.data.message,isOpen:true,type:'warning'})
        }
      })
    }
  }

  useEffect(()=>{
    if(connectedToDB){
      dispatch(api.endpoints.get_database_table_info.initiate({
        account:account,
        user:user
      }))
      .then(res=>{
        if(res?.data?.current_state === 'SUCCESS'){
          const tableList = res?.data?.data?.database_table_list || [];
          dispatch(treeActions.setConnectedDbTableList({
            screen:parentScreen,
            value:tableList
          }))
        }
      })
    }else{
      dispatch(treeActions.setConnectedDbTableList({
        screen:parentScreen,
        value:[]
      }))
    }
    
  },[connectedToDB])

  useEffect(() => {
    setPdcInLoading(pdcRes.isLoading);
    setConnectionOptions(
      pdcRes.isSuccess && pdcRes.data.predefined_connections?.length ? 
        pdcRes.data.predefined_connections.map(e => {return {label: e}})
        : []
    );
  }, [pdcRes.data]);

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    setConnection(header.PREDEFINED_CONNECTION || '');
    setColumnsSorted(
      header.SORT_DB_COLUMNS ?
        (typeof header.SORT_DB_COLUMNS === 'boolean' && header.SORT_DB_COLUMNS) || header.SORT_DB_COLUMNS === "TRUE" || false
        : false
    );
    setDecodeData(
      header.URLDECODE ?
        (typeof header.URLDECODE === 'boolean' && header.URLDECODE) || header.URLDECODE === "TRUE" || false
        : false
    );
    setIncludeNull(
      header.INCLUDE_NULL ?
      (typeof header.INCLUDE_NULL === 'boolean' && header.INCLUDE_NULL) || header.INCLUDE_NULL === "TRUE" || false
      : false
    )
  }, [rightTree.tree.templateHeader])

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value }));
  }

  const debouncedSave = useCallback(
		debounce(
			(prop, newVal, tData, currTab) =>
				changePropOnAllFields(prop, newVal, tData, currTab, dispatch, parentScreen),
			200,
			true
		),
		[]
	);


  return (
    <>
      {/* <div className="flex width-100">
        <Autocomplete
          size="small"
          variant="outlined"
          className='width-100'
          freeSolo
          disabled={connectedToDB}
          autoSelect
          loading={pdcInLoading}
          options={connectionOptions}
          value={connection}
          inputValue={connectionInput}
          onChange={(event, newValue) => {
            handleChange('PREDEFINED_CONNECTION',newValue?.label || '')
            setConnection(newValue?.label || '');
          }}
          onInputChange={(event, newInputValue) => {
            handleChange('PREDEFINED_CONNECTION',newInputValue)
            setConnectionInput(newInputValue);
          }}
          renderInput={(params) => <TextField size="small" variant="outlined" {...params} label={t("LBL_DATA_CONN")} />}
        />
        <Button
          variant="outlined"
          size="small"
          disableElevation
          className='margin-left-4'
          sx={{
            width: '40px', 
            padding: '4px 8px',
            minWidth: '40px',
          }}
          onClick={() => alert('PDC Popup is still in development.')}
        >
          <MoreHorizIcon fontSize="small"/>
        </Button>
      </div> */}
      <div className='flex flex-wrap'>
        {/* <TPCheckbox 
            label={t('BTN_SORT_DB_COLUMNS')}
            checked={columnsSorted}
            handleCheck={(checked) => {
              setDecodeData(checked);
              handleChange('SORT_DB_COLUMNS', checked);
            }}
        /> */}
        {parentScreen === 'outbound' && <TPCheckbox 
            label={t('BTN_INCLUDE_NULL_IN_SQL')}
            checked={includeNull}
            handleCheck={(checked) => {
              handleChange('INCLUDE_NULL', checked);
              debouncedSave("INCLUDE_NULL", checked, tDataAllTabs, rightTree.currentTab);
              setIncludeNull(checked);
            }}
        />}
      </div>
      {/* <Button
        variant="outlined"
        size="small"
        disableElevation
        className='width-100 margin-top-4'
        onClick={connectToDatabaseHandler}
      >
        {t(connectedToDB ? 'BTN_DISCONN_FROM_DB' : 'BTN_CONNECT_TO_SEL_DB' )}
      </Button> */}
      {parentScreen === 'inbound' && 
      <div className='margin-top-4'>
        <TPCheckbox 
          label={t('BTN_URLDECODE_DATA')}
          checked={decodeData}
          handleCheck={(checked) => {
            setDecodeData(checked);
            handleChange('URLDECODE', checked);
          }}
        />
      </div>}
      <Snackbar
        open={showAlert.isOpen}
        autoHideDuration={4000}
        onClose={()=>setShowAlert(prev=>{return {mssg:'',type:prev.type,isOpen:false}})}>
        <Alert severity={showAlert.type} sx={{ width: "100%" }}>
          {showAlert.mssg}
        </Alert>
      </Snackbar>
    </>
  )
}